import { CommandContribution, CommandRegistry } from '@theia/core';
import { ApplicationShell, CommonCommands, Widget } from '@theia/core/lib/browser';
import { inject, injectable } from '@theia/core/shared/inversify';

/**
 * Theia's built-in `core.close.main.tab` handler is only enabled while a closable widget is
 * current in the main area, so closing the last editor tab leaves the command with no active
 * handler — the keybinding still fires it, which rejects as an uncaught "no active handlers"
 * error. That's not just "no widget at all": with no editors open, the main area falls back to
 * the non-closable Project Overview widget (see project-overview.tsx's `title.closable = false`),
 * which still counts as a "current widget". Register a no-op fallback covering both cases so the
 * keybinding is silently ignored instead.
 */
@injectable()
export class CloseLastEditorContribution implements CommandContribution {
    @inject(ApplicationShell)
    protected readonly shell!: ApplicationShell;

    registerCommands(commands: CommandRegistry): void {
        commands.registerHandler(CommonCommands.CLOSE_MAIN_TAB.id, {
            isEnabled: (): boolean => {
                const currentWidget: Widget | undefined = this.shell.getCurrentWidget('main');
                return currentWidget === undefined || !currentWidget.title.closable;
            },
            execute: (): void => undefined
        });
    }
}
